<script setup>
import { onMounted, ref, reactive } from 'vue'
import router from '@/router'
import { useCartStore } from '@/stores/cartStore'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/userStore';
import { goUp, goRate, exchangeRate, valueRange } from "@/utils/index"
const { t } = useI18n();
const userStore = useUserStore()
const cartStore = useCartStore()
const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    cartStore.updateNewList()
})

// 单选回调
const singleCheck = (id, skuId, userId, selected) => {
    console.log('单选')
    cartStore.singleCheck(id, skuId, userId, selected)
    selectedItems.value = cartStore.cartList.map(user => {
        if (user.shop_user_id == userId) {
            user.list.map(item => {
                if (id == item.id) {
                    if (skuId == item.sku_id) {
                        // 给每个item添加selected属性，并设置为true
                        item.selected = selected;
                    }

                }
            });
        }
    })
    // cartStore.cartList=selectedItems.value
}
/**
 * 用户全选
 * @param i 
 * @param selected 
 */
const userAllCheck = (i, selected) => {
    console.log('全选')
    cartStore.userAllCheck(i, selected)
    selectedItems.value = cartStore.cartList.map(user => {
        if (user.shop_user_id == i) {
            user.selected = selected
            user.list.map(item => {

                if (item.inventory != 0 && item.status!=2) {
             
                    // 给每个item添加selected属性，并设置为true
                    item.selected = selected;
                } else {
                 
                    item.selected = false;
                }
            });
        }


    })
}
/**
 * 
 * @param selected 全选
 */
const allCheck = (selected) => {
    cartStore.allCheck(selected)
    selectedItems.value = cartStore.cartList

}
/**
 * 删除
 * @param userId 
 * @param id 
 */
const onDel = (type, userId, id, skuid) => {
    console.log(type, userId, id, skuid)
    let isdel=[]
    cartStore.cartList.forEach(el=>{
        console.log('el',el)
        el.list.forEach(i=>{
            if(i.selected){
                isdel.push({ product_id: i.id, sku_id: i.sku_id})
            }
            }
        )
    })
    console.log(isdel)
        if(isdel?.length>0 || userId){

       

        ElMessageBox.confirm(
        t('number111'),
        t('cart10'),
        {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
            //   center: true,
        }
    )
        .then(() => {
            let data = []
            if (type == 2) {//表示单个删除
                console.log(userId, id, skuid)
                data = [{ product_id: id, sku_id: skuid }]
            } else {
               data=isdel
            }
            cartStore.delCart(data)

        })
        .catch((e) => {
            console.log('err',e)

            ElMessage({
                type: 'info',
                message: t('number113'),
            })
        })
    }else{
        
        ElMessage({
                type: 'warning',
                message: t('setup580'),
            })
    }


    
}
const handleChange = (value, id) => {
    console.log('value',value)
    if(value.quantity<1){//删除
        onDel(2,id,value.id,value.sku_id)
    }else{
        const sku = {
            sku_id: value.sku_id,
            properties_name: value.sku_name,

        }
        cartStore.addCart({
            // inventory: value.quantity || 999,
            edit:true,
            shop_user_id: id,
            id: value.id, // 商品id
            // name: value.name, // 商品名称
            // picture: value.cover_url, // 图片
            // price: value.price, // 最新价格
            // needIntlPostage:value.needIntlPostage,//需要国际邮费
            description: value.description, // 商品规格文本
            // selected: value.selected, // 商品是否选中
            num: value.quantity,
            sku:sku,
            // from: 'cart',
            sku_info: sku,
            source: value.source
            // coverUrl: goods.value.coverUrl
        })
    }
 



}
const PlaceAnOrder = () => {
    localStorage.removeItem('thirdData');
    localStorage.setItem('order', '')
    console.log('购物车数据',cartStore.checkoutList)
    for (const item of cartStore.checkoutList) {
        for (const z of item.list) {
            console.log('zzzzz',z)
            if (z.selected && z.inventory < z.quantity) {
                ElMessage({
                    message: t('setup24'),
                    type: 'warning',
                });
                return; // 这将终止整个外部循环
            }
        }
    }
    if(cartStore.checkoutList.length>0){
        router.push("/checkout")
    }
    

}
/**
 * 点击跳转到商品详情页
 * @param id 商品id
 * @param source 商品来源
 */
const goDetailUrl = (id, source) => {
   
        if (source == '') {
            router.push("/detail/" + id)
        } else {
            let data = { product_id: id, from: source }
            let objectString = JSON.stringify(data);
            localStorage.setItem('thirdData', objectString)
            //进入第三方详情
            // router.push('/externals') 
            router.push({ path: '/externals/' + source + '/' + id })
        }

 
}
const selectedItems = ref([])
const isMore = ref(true)
const goBack = () => {
    router.go(-1);
}
</script>

<template>
    <div class="xtx-cart-page">
        <div class="container m-top-20">
            <div class="cart" v-if="isMobile == false">
                <div class="thead-title">
                    <div class="check"> <!-- 全选框 -->
                        <el-checkbox :model-value="cartStore.isAll" @change="allCheck" />
                    </div>
                    <div class="name">{{ $t('cart1') }}

                        <img @click="onDel(1)" src="../../assets/images/dels.png" style="width: 18px;height: 20px;"
                            alt="" srcset="">
                    </div>
                    <div class="price">{{ $t('cart2') }}</div>
                    <div class="number">{{ $t('cart3') }}</div>
                    <div class="total">{{ $t('cart4') }}</div>
                    <div class="operate">{{ $t('cart5') }}</div>
                </div>
                <div class="content">
                    <div v-for="(list, index) in cartStore.cartList" :key="index">
                        <div class="username alignflex"> <el-checkbox :model-value="list.selected"
                                @change="(selected) => userAllCheck(list.shop_user_id, selected)" />
                            <img :src="list.avatar" alt="" srcset="" style="margin-left:19px;width: 20px;height: 20px;">
                            <span class="user">{{ list.shop_user }}</span>
                        </div>
                        <div class="cardThead">
                            <div class="thead" v-for="i in list.list" :key="i.id">
                                <div class="check"> <!-- 全选框 -->
                                    <el-checkbox :model-value="i.selected"
                                        @change="(selected) => singleCheck(i.id, i.sku_id, list.shop_user_id, selected)"
                                        :disabled="i.inventory == 0 ||i.status==2" />
                                </div>
                                <div class="name">
                                    <div class="goods">
                                        <img :src="i.cover_url" @click="goDetailUrl(i.id,  i.source)" alt="" />
                                        <div>
                                            <div @click="goDetailUrl(i.id,  i.source)">
                                                <div class="title ellipsis">{{ i.name }}</div>
                                                <div class="sku ellipsis">{{ i.sku_name }}</div>
                                                <div class="sku" style=" color: red;" v-if="i.needIntlPostage"><span >{{ $t('setup670') }}</span></div>
                                            </div>
                                            <p class="phone" style="padding: 8px 0px;"><el-input-number v-model="i.quantity"
                                                    style="width: 100px;" :min="1" size="small"
                                                    @change="handleChange(i, list.shop_user_id,)"
                                                    :disabled="i.inventory == 0" />
                                            </p>
                                            <div class="phone red">{{ $t('cart6') }}: <span
                                                    v-if="userStore.exchangeRate.symbol == '￥'">¥{{ i.price }}</span>
                                                <span v-else>{{
                                                    exchangeRate(i.price,
                                                        userStore.exchangeRate.symbol, userStore.exchangeRate.rate)
                                                    }}</span> | <span v-if="userStore.exchangeRate.symbol == '￥'">¥{{
                                                        goUp(i.price *
                                                    i.quantity) }}</span>
                                                <span v-else> {{ userStore.exchangeRate.symbol }}{{
                                                    valueRange(goRate(i.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)
                                                    *
                                                    i.quantity )}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>

                                    </div>
                                </div>
                                <div class="price pc">
                                    <p><span v-if="userStore.exchangeRate.symbol == '￥'">¥{{ i.price }}</span>
                                        <span v-else>{{
                                            exchangeRate(i.price,
                                                userStore.exchangeRate.symbol,userStore.exchangeRate.rate) }}</span>
                                    </p>
                                </div>
                                <div class="number pc"> <el-input-number v-model="i.quantity" :min="1"
                                        @change="handleChange(i, list.shop_user_id)" style="width: 130px;" /></div>
                                <div class="total pc">
                                    <p class="f16 red"></p>

                                    <p class="f16 red"><span v-if="userStore.exchangeRate.symbol == '￥'">¥{{
                                        goUp(i.price *
                                            i.quantity)}}</span>
                                        <span v-else>
                                            {{ userStore.exchangeRate.symbol }}{{
                                                valueRange(goRate(i.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)
                                            *
                                            i.quantity) }}
                                            <!-- {{ exchangeRate(goRate(i.price,userStore.exchangeRate.symbol,userStore.exchangeRate.rate) *
                                                i.num, userStore.exchangeRate.symbol,userStore.exchangeRate.rate) }} -->
                                        </span>
                                    </p>
                                </div>
                                <div class="operate pc">
                                    <p>
                                        <!-- <el-popconfirm :title="t('cart7')" :confirm-button-text="t('cart8')"
                                            :cancel-button-text="t('cart9')" @confirm="onDel(2,list.shop_user_id, i.id,i.sku_info.sku_id)">
                                            <template #reference> -->

                                        <img src="../../assets/images/dels.png" style="width: 18px;height: 20px;"
                                            @click="onDel(2, list.shop_user_id, i.id, i.sku_id)" alt=""
                                            srcset="">
                                        <!-- <a href="javascript:;" class="red">{{ $t('cart10') }}</a> -->
                                        <!-- </template>
</el-popconfirm> -->
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="cartStore.cartList.length === 0">
                        <div class="cart-none">
                            <el-empty :description="t('cart11')">

                            </el-empty>
                        </div>
                    </div>
                </div>
            </div>
            <div class="phoneCart">
                <div class="top" v-if="isMobile == true">
                    <div class="divcontent">
                        <div @click="goBack()"><img src="../../assets/images/return1.png" alt="" srcset=""
                                style="width: 22px;height: 18px;"></div>
                        <div>{{ $t('number12') }}</div>
                        <div>
                            <img v-if="isMore == true" @click="isMore = false" src="../../assets/images/gengduo.png" alt=""
                                srcset="" style="width: 22px;height: 22px;">
                            <p v-else class="toptitle" @click="isMore = true">{{ $t('setup499') }}</p>
                        </div>
                    </div>
                </div>
                <div class="CartContent" v-if="isMobile == true">
                    <div class="carditem" v-for="(list, index) in cartStore.cartList" :key="index">
                        <div class="username alignflex"> <el-checkbox :model-value="list.selected"
                                @change="(selected) => userAllCheck(list.shop_user_id, selected)" />
                            <img :src="list.avatar" alt="" srcset="" style="margin-left:10px;width: 20px;height: 20px;">
                            <span class="user">{{ list.shop_user }}</span>
                        </div>
                        <div class="cardThead">
                            <div class="thead" v-for="i in list.list" :key="i.id">
                                <div class="check"> <!-- 全选框 -->
                                    <el-checkbox :model-value="i.selected"
                                        @change="(selected) => singleCheck(i.id, i.sku_id, list.shop_user_id, selected)"
                                        :disabled="i.inventory == 0" />
                                </div>
                                <div class="name">
                                    <div class="goods">
                                        <img :src="i.cover_url" @click="goDetailUrl(i.id,  i.source)" alt="" />
                                        <div class="Product">
                                            <div @click="goDetailUrl(i.id,  i.source)">
                                                <div class="title ellipsis">{{ i.name }}</div>
                                                <div class="sku ellipsis">{{ i.sku_name }}*{{ i.quantity }}
                                                </div>
                                            </div>
                                            <div class="priceNum">
                                                <div class="numprice"><span
                                                        v-if="userStore.exchangeRate.symbol == '￥'">¥{{
                                                            goUp(i.price *
                                                        i.quantity) }}</span>
                                                    <span v-else> {{ userStore.exchangeRate.symbol }}{{
                                                        valueRange(goRate(i.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)
                                                        *
                                                        i.quantity )}}
                                                    </span>
                                                </div>
                                                <div>
                                                    <el-input-number v-model="i.quantity" style="width: 100px;height: 30px;"
                                                        @change="handleChange(i, list.shop_user_id,)"
                                                        :disabled="i.inventory == 0">
                                                        <template #decrease-icon>

                                                            <svg-icon v-if="i.quantity > 1" icon-class="jian" />
                                                            <svg-icon v-else icon-class="del" />
                                                        </template>
                                                        <template #increase-icon>
                                                            <svg-icon icon-class="jia" />
                                                        </template>
                                                    </el-input-number>
                                                    <!-- <el-input-number v-model="i.num"  style="width: 65px;height: 22px;" >
                                                        <template #prefix>
                                                            111
                                                        </template>
                                                        <template #suffix>
                                                            22
                                                        </template>
                                                    </el-input-number> -->
                                                    <!-- <el-input-number v-model="i.num"
                                                style="width: 65px;"
                                                    :min="1" size="small" @change="handleChange(i, list.shop_user_id,)" :disabled="i.inventory==0"/> -->
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div>

                                    </div>
                                </div>
                                <div class="price pc">
                                    <p><span v-if="userStore.exchangeRate.symbol == '￥'">¥{{ i.price }}</span>
                                        <span v-else>{{
                                            exchangeRate(i.price,
                                                userStore.exchangeRate.symbol,userStore.exchangeRate.rate)
                                            }}</span>
                                    </p>
                                </div>
                                <div class="number pc"> <el-input-number v-model="i.quantity" :min="1"
                                        @change="handleChange(i, list.shop_user_id)" style="width: 130px;" /></div>
                                <div class="total pc">
                                    <p class="f16 red"></p>

                                    <p class="f16 red"><span v-if="userStore.exchangeRate.symbol == '￥'">¥{{
                                        goUp(i.price *
                                            i.quantity)}}</span>
                                        <span v-else>
                                            {{ userStore.exchangeRate.symbol }}{{
                                                valueRange(goRate(i.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)
                                            *
                                            i.quantity) }}
                                            <!-- {{ exchangeRate(goRate(i.price,userStore.exchangeRate.symbol,userStore.exchangeRate.rate) *
                                                i.num, userStore.exchangeRate.symbol,userStore.exchangeRate.rate) }} -->
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="cartStore.cartList.length === 0">
                        <div class="cart-none">
                            <el-empty :description="t('cart11')">

                            </el-empty>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 操作栏 -->
            <div class="action">
                <div class="HorizontalCenter" v-if="isMobile == true">
                    <el-checkbox :model-value="cartStore.isAll" @change="allCheck" style="margin-right: 5px;" />{{
                    $t('setup472') }}
                </div>
                <div class="batch pc">
                    {{ $t('home13') }} {{ cartStore.allCount }} {{ $t('cart12') }}
                    <span class="red"><span v-if="userStore.exchangeRate.symbol == '￥'">¥{{
                        goUp(cartStore.selectedPrice) }}</span>
                        <span v-else>{{ userStore.exchangeRate.symbol }}{{
                            goUp(cartStore.selectedPrice)
                        }} </span>
                    </span>
                </div>
                <div class="total pc">
                    <!--  -->
                    <el-button size="large" type="primary" :disabled="selectedItems.length === 0"
                        @click="PlaceAnOrder()">{{
                            $t('cart14') }}</el-button>
                </div>
                <div class="totalphone" v-if="isMobile == true && isMore == true">
                    <div>
                        <p class="Total"> {{ $t('home13') }} {{ cartStore.allCount }} {{ $t('home14') }}</p>
                        <p class="Paymentprice">{{ $t('cart13') }}：
                            <span><span v-if="userStore.exchangeRate.symbol == '￥'">¥{{
                                    goUp(cartStore.selectedPrice)}}</span>
                                <span v-else>{{ userStore.exchangeRate.symbol }}{{
                                    goUp(cartStore.selectedPrice)
                                    }}</span> </span>
                        </p>
                    </div>
                    <el-button style="margin-left: 8px;" type="primary" :disabled="selectedItems.length === 0"
                        @click="PlaceAnOrder()">{{
                            $t('cart14')
                        }}</el-button>
                </div>
                <div class="totalphone" v-if="isMobile == true && isMore == false">
                    <div class="del" @click="onDel(1)">{{ $t('number119') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.el-button {
    background: #FC3938;
    border-radius: 23px;
    padding: 0 77px;
}

.pc {
    display: block;
}

.phone {
    display: none;
}

.container {
    width: 100%;
}


.xtx-cart-page {
    // margin-top: 20px;
    background-color: #eef0f1;
    .cart {
        background: #fff;
        color: #666;
        border-radius: 8px;
        padding: 20px;

        .thead-title {
            padding: 0 20px;
            background: #FFF1EB;
            border-radius: 8px;
            height: 56px;
            display: flex;
            align-items: center;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #11192D;
            line-height: 19px;
            font-style: normal;
        }

        .check {
            width: 35px;
            color: #11192D;
        }

        .name {
            width: 320px;
            color: #11192D;
        }

        .price {
            width: 100px;
            color: #11192D;
            text-align: center;
        }

        .number {
            width: 150px;
            color: #11192D;
            text-align: center;
        }

        .total {
            width: 130px;
            text-align: center;
        }

        .operate {
            width: 80px;
            text-align: end;
        }

        .cardThead {
            border-radius: 0px 0px 8px 8px;
            border: 1px solid #E5E8EC;
            border-top: none;

            .thead:nth-child(even) {
                border-top: 1px solid #E5E8EC;
                border-bottom: 1px solid #E5E8EC;

            }
        }

        .thead {
            display: flex;
            align-items: center;
            padding: 15px 20px;

            .check {
                width: 35px;
            }

            .name {
                width: 320px;

                .goods {
                    display: flex;
                    align-items: center;

                    .image {
                        width: 82px;
                        height: 82px;
                        border-radius: 8px;
                    }

                    img {
                        width: 82px;
                        height: 82px;
                        border-radius: 8px;
                    }

                    >div {
                        .title {
                            font-family: MicrosoftYaHei, MicrosoftYaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #11192D;
                            line-height: 25px;
                            text-align: left;
                            font-style: normal;
                        }

                        .sku {
                            padding-top: 6px;
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            color: #666666;
                            line-height: 19px;
                            text-align: left;
                            font-style: normal;
                        }

                        width: 215px;
                        font-size: 16px;
                        padding-left: 13px;

                        .attr {
                            font-size: 14px;
                            color: #999;
                        }
                    }
                }
            }

            .price {
                width: 100px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #666666;
                line-height: 19px;
                text-align: center;
                font-style: normal;
            }

            .number {
                width: 150px;
                color: #11192D;
                text-align: center;
            }

            .total {
                width: 130px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FC3938;
                line-height: 19px;
                text-align: center;
                font-style: normal;
            }

            .operate {
                width: 80px;
                text-align: end;
            }

        }

        .content {
            .username {
                margin-top: 20px;
                background: #F3F6F8;
                border-radius: 8px 8px 0px 0px;
                padding: 10px 20px;
                // border-bottom: 1px solid #aaaaaa;

                .user {
                    padding-left: 8px;
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    line-height: 21px;
                    text-align: left;
                    font-style: normal;
                }
            }
        }

        table {
            border-spacing: 0;
            border-collapse: collapse;
            line-height: 24px;

            th,
            td {
                padding: 10px;
                border-bottom: 1px solid #f5f5f5;

                &:first-child {
                    text-align: left;
                    padding-left: 30px;
                    color: #999;
                }
            }

            th {
                font-size: 16px;
                font-weight: normal;
                line-height: 50px;
            }
        }
    }

    .cart-none {
        text-align: center;
        padding: 120px 0;
        background: #fff;

        p {
            color: #999;
            padding: 20px 0;
        }
    }

    .tc {
        text-align: center;

        a {
            color: $xtxColor;
        }

        .xtx-numbox {
            margin: 0 auto;
            width: 120px;
        }
    }

    .red {
        color: $priceColor;
    }

    .green {
        color: $xtxColor;
    }

    .f16 {
        font-size: 16px;
    }

    .goods {
        display: flex;
        align-items: center;

        img {
            width: 100px;
            height: 100px;
        }

        >div {
            width: 280px;
            font-size: 16px;
            padding-left: 10px;

            .attr {
                font-size: 14px;
                color: #999;
            }
        }
    }

    .action {
        display: flex;
        background: #fff;
        margin-top: 20px;
        height: 100px;
        align-items: center;
        font-size: 16px;
        justify-content: space-between;
        padding: 0 30px;
        border-radius: 8px;

        .xtx-checkbox {
            color: #999;
        }

        .batch {
            a {
                margin-left: 20px;
            }
        }

        .red {
            font-size: 18px;
            margin-right: 20px;
            font-weight: bold;
        }
    }

    .tit {
        color: #666;
        font-size: 16px;
        font-weight: normal;
        line-height: 50px;
    }

}

@media (max-width: 768px) {
    :deep(.el-input-number .el-input__wrapper){
        padding-left: 13px;
        padding-right: 13px;
    }
    .el-button {
        background: #FC3938;
        border-radius: 23px;
        padding: 0 36px;
    }

    /* 覆盖复选框外层容器的样式 */
    .el-checkbox:deep(.el-checkbox__inner) {
        border-radius: 50% !important;
        /* 圆形 */
        width: 16px;
        /* 调整宽度 */
        height: 16px;
        /* 调整高度 */
    }

    /* 选中状态时的勾号图标 */
    .el-checkbox:deep(.el-checkbox__inner::after ){
        border-color: #fff;
        /* 勾号颜色 */
        left: 5px;
        /* 调整勾号位置 */
        top: 2px;
    }

    /* 选中状态背景色 */
    .el-checkbox:deep(.el-checkbox__input.is-checked .el-checkbox__inner ){
        background-color: #FC3938;
        /* 选中背景色 */
        border-color: #FC3938;
    }

    /* 禁用状态 */
    .el-checkbox:deep(.is-disabled .el-checkbox__inner){
        background-color: #f5f7fa;
        border-color: #e4e7ed;
    }

    .pc {
        display: none !important;
    }

    .phone {
        display: block;
    }

    .xtx-cart-page {
        background-color: #f7f7f7;
        // min-height: 100vh;
        // margin-top: 20px;
        height: auto;
        // min-height: 100vh;
        .container {
        //    min-height: 100vh;
        }

        .phoneCart {
            .top {
                position: fixed;
                background: #fff;
                width: 100%;
                height: 45px;
                z-index: 9999;

                // padding: 0 20px;
                .divcontent {
                    padding: 10px 15px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #222222;
                    line-height: 25px;
                    text-align: right;
                    font-style: normal;
                    display: flex;
                    justify-content: space-between;
                    /* padding: 13px 0; */
                    // height: 50px;
                    align-items: center;

                }

                .toptitle {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                }
            }

            .CartContent {
                
                padding-top: 44px;
                padding-bottom: 129px;
            }

            .carditem {
                margin: 15px;
                background: #FFFFFF;
                box-shadow: 0px 4px 20px 6px rgba(237, 237, 237, 0.75);
                border-radius: 4px;
                padding: 15px 15px 0 15px;

                .cardThead {
                    padding-top: 23px;

                    .thead {
                        display: flex;
                        align-items: center;
                        // padding: 15px 15px;
                        padding-bottom: 23px;

                        .check {
                            // width: 26px;
                            margin-right: 10px;
                        }

                        .name {
                            width: 400px;

                            .goods {
                                display: flex;
                                align-items: flex-start;



                                img {
                                    width: 82px;
                                    height: 82px;
                                    border-radius: 8px;
                                }

                                .Product {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    height: 82px;
                                    flex: 1;

                                    .title {
                                        font-family: PingFangSC, PingFang SC;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #222222;
                                        line-height: 20px;
                                        text-align: left;
                                        font-style: normal;
                                    }

                                    .sku {
                                        font-family: PingFangSC, PingFang SC;
                                        font-weight: 400;
                                        font-size: 12px;
                                        color: #888888;
                                        line-height: 17px;
                                        text-align: left;
                                        font-style: normal;
                                    }

                                    .priceNum {
                                        width: 100%;
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: flex-end;

                                        .numprice {
                                            font-family: PingFangSC, PingFang SC;
                                            font-weight: 500;
                                            font-size: 18px;
                                            color: #FF4F00;
                                            line-height: 14px;
                                            text-align: left;
                                            font-style: normal;
                                        }
                                    }
                                }

                                >div {
                                    width: 207px;
                                    // border: 1px solid;
                                    //     font-size: 14px;
                                    //     padding-left: 5px;


                                    //     .attr {
                                    //         font-size: 14px;
                                    //         color: #999;
                                    //     }
                                }
                            }
                        }

                        // .price {
                        //     width: 220px;
                        // }

                        // .total {
                        //     width: 180px;
                        // }

                        // .operate {
                        //     width: 50px;
                        // }
                    }
                }
            }
        }

        .cart {
            padding-top: 37px;
            background: #fff;
            color: #666;

            .thead {
                display: flex;
                align-items: center;
                padding: 15px 15px;

                .check {
                    width: 40px;
                }

                .name {
                    width: 400px;

                    .goods {
                        display: flex;
                        align-items: flex-start;

                        .image {
                            width: 80px;
                            height: 80px;
                        }

                        img {
                            width: 80px;
                            height: 80px;
                        }

                        >div {
                            width: 180px;
                            font-size: 14px;
                            padding-left: 5px;


                            .attr {
                                font-size: 14px;
                                color: #999;
                            }
                        }
                    }
                }

                .price {
                    width: 220px;
                }

                .total {
                    width: 180px;
                }

                .operate {
                    width: 50px;
                }
            }

            .content {
                padding-bottom: 136px;

                .username {
                    padding: 18px 15px 10px 15px;
                    border-bottom: 1px solid #aaaaaa;

                    .user {
                        padding-left: 20px;
                    }
                }
            }

            table {
                border-spacing: 0;
                border-collapse: collapse;
                line-height: 24px;

                th,
                td {
                    padding: 10px;
                    border-bottom: 1px solid #f5f5f5;

                    &:first-child {
                        text-align: left;
                        padding-left: 30px;
                        color: #999;
                    }
                }

                th {
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 50px;
                }
            }
        }

        .cart-none {
            min-height:calc(100vh - 174px);
            text-align: center;
            padding:0px 0;
            background: #fff;

            p {
                color: #999;
                padding: 20px 0;
            }
        }

        .tc {
            text-align: center;

            a {
                color: $xtxColor;
            }

            .xtx-numbox {
                margin: 0 auto;
                width: 120px;
            }
        }

        .red {
            color: $priceColor;
        }

        .green {
            color: $xtxColor;
        }

        .f16 {
            font-size: 16px;
        }

        .goods {
            display: flex;
            align-items: center;

            img {
                width: 100px;
                height: 100px;
            }

            >div {
                width: 280px;
                font-size: 16px;
                padding-left: 10px;

                .attr {
                    font-size: 14px;
                    color: #999;
                }
            }
        }

        .action {
            width: 100%;
            position: fixed;
            bottom: 0px;
            display: flex;
            background: #fff;
            margin-top: 20px;
            height: 60px;
            align-items: center;
            font-size: 14px;
            justify-content: space-between;
            padding: 0 15px;
            z-index: 99;
            border-radius: 0px;

            .totalphone {

                display: flex;

                .del {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #FC3938;
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                }

                .Total {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #777777;
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                }

                .Paymentprice {
                    padding-top: 4px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #FF4F00;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }
            }

            .xtx-checkbox {
                color: #999;
            }

            .batch {
                flex: 1;
                padding: 0 15px;

                a {
                    margin-left: 20px;
                }
            }

            .red {
                font-size: 14px;
                margin-right: 20px;
                font-weight: bold;
            }
        }

        .tit {
            color: #666;
            font-size: 16px;
            font-weight: normal;
            line-height: 50px;
        }

    }
}
</style>